export default "__VITE_ASSET__64dc2917__"